import React from 'react';
import '../App.css';
import 'materialize-css';
import {Navbar, NavItem, Icon} from 'react-materialize';
import {Link, NavLink} from "react-router-dom";
import VkAuth from "react-vk-auth";
import AuthFromVK from "./AuthFromVK";


class MainNavbar extends React.Component{
    constructor(props) {
        super(props);

    }
    //kjkk
    render() {
        return (
            <div className="navbar-fixed">
                <Navbar
                    brand={<Link to='/' className='center'><Icon large>enhanced_encryption</Icon></Link>}
                    alignLinks="right" className='purple darken-4'
                    menuIcon={<div style={{color: "#c5c5c5"}}><Icon >menu</Icon></div>}
                    sidenav={[
                        <li><Link to='/'>Основной метод</Link></li>,
                        <li><Link to='/hard/'>Сложный метод</Link></li>,
                        <li><Link to='/des/'>DES</Link></li>,
                        <li><Link to='/aes/'>AES</Link></li>,
                        <li><Link to='/md5/'>MD5 Hash</Link></li>,
                        <li>{!this.props.auth ?
                            <NavLink to='/login/' className='text-primary-color waves-effect waves-dark'>Войти</NavLink>
                            : <NavLink to='/myAccount/' className='text-primary-color  waves-effect waves-dark'>Аккаунт</NavLink>}</li>
                    ]}
                >
                    <NavLink to='/' className='text-primary-color  waves-effect waves-dark'>
                        Основной метод
                    </NavLink>

                    <NavLink to='/hard/' className='text-primary-color  waves-effect waves-dark'>
                        Сложный метод
                    </NavLink>

                    <NavLink to='/des/' className='text-primary-color  waves-effect waves-dark'>
                        DES
                    </NavLink>

                    <NavLink to='/aes/' className='text-primary-color  waves-effect waves-dark'>
                        AES
                    </NavLink>

                    <NavLink to='/md5/' className='text-primary-color  waves-effect waves-dark'>
                        MD5 Hash
                    </NavLink>

                    {!this.props.auth ?
                        <NavLink to='/login/' className='text-primary-color waves-effect waves-dark'>Войти</NavLink>
                        : <NavLink to='/myAccount/' className='text-primary-color  waves-effect waves-dark'>Аккаунт</NavLink>}
                </Navbar>
            </div>
        );
    }
}

export default MainNavbar;
